import { PaginatedResponse } from "@/interfaces/paginatedResponse";
import { Company } from "@/modules/companies/interfaces/company";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useCompaniesStore = defineStore("companies", () => {
  const companies = ref<Company[]>([]);
  const corporate = ref<number>();
  const company = ref<number>();
  const includes = ref<String[]>([]);
  const page = ref<number>(1);

  return {
    corporate,
    company,
    includes,
    companies,
    page,

    params: computed(() => {
      return {
        corporate: corporate.value,
        company: company.value,
        includes: includes.value,
      };
    }),

    setPage: (newPage: number) => {
      page.value = newPage;
    },
    setCompanies: (newCompanies: Company[]) => {
      companies.value = newCompanies;
    },
    setCompany: (newCompany: number | undefined) => {
      company.value = newCompany;
    },
    setCorporate: (newCorporate: number | undefined) => {
      corporate.value = newCorporate;
    },
    resetState() {
      companies.value = [];
    },
  };
});
